import React, { useContext, useEffect, useState } from 'react';
import './Header.module.scss';
import { motion, useViewportScroll } from 'framer-motion';
import { useHistory } from 'react-router-dom';
import { useMediaQ } from 'hooks/useMediaQ';
import { HomeContext } from 'screens/Home/Home';

type Props = {
  filterMenu?: boolean;
};

export default function Header({ filterMenu }: Props) {
  const history = useHistory();
  const { scrollYProgress } = useViewportScroll();

  const { setActiveFilters } = useContext(HomeContext);

  const mediaQ = useMediaQ('min', 1024);

  const [menuOpen, setMenuOpen] = useState(false);
  const [scrollPos, setScrollPos] = useState(0.0);

  useEffect(() => scrollYProgress.onChange((v) => setScrollPos(v)), []);

  return (
    <>
      <div styleName="menu-bar">
        <div styleName="inner ">
          <div styleName="menu-items">
            <p onClick={() => history.push('/pagina/over-youtoo')}>
              Over #YouToo?
            </p>
          </div>

          <motion.div
            initial={filterMenu ? { opacity: 0 } : { opacity: 1 }}
            animate={
              scrollPos < 0.05 && filterMenu && mediaQ
                ? { opacity: 0 }
                : { opacity: 1 }
            }
          >
            <img
              styleName={`image ${filterMenu ? 'filtermenu' : ''}`}
              onClick={() => {
                history.push('/');
                setActiveFilters([]);
              }}
              alt="logo"
              src="/images/youtoo-logo-small.png"
            />
          </motion.div>

          <div
            onClick={() => setMenuOpen((prev) => !prev)}
            styleName="hamburger-menu"
          >
            <img alt="hamburger-menu-icon" src="/images/hamburger-icon.png" />
          </div>

          <div styleName="menu-items">
            <p onClick={() => history.push('/pagina/deel-jouw-kennis')}>
              Deel jouw kennis
            </p>
            <p onClick={() => history.push('/pagina/partners')}>Partners</p>
          </div>
        </div>
        {menuOpen && (
          <>
            <div styleName="hamburger-menu-overlay">
              <div styleName="inner-mobile">
                <img
                  styleName={`image ${filterMenu ? 'filtermenu' : ''}`}
                  onClick={() => {
                    history.push('/');
                    setActiveFilters([]);
                    setMenuOpen(false);
                  }}
                  alt="logo"
                  src="/images/youtoo-logo-small.png"
                />
                <p
                  onClick={() => {
                    history.push('/pagina/over-youtoo');
                    setMenuOpen(false);
                  }}
                >
                  Over #YouToo?
                </p>
                <p
                  onClick={() => {
                    history.push('/pagina/deel-jouw-kennis');
                    setMenuOpen(false);
                  }}
                >
                  Deel jouw kennis
                </p>
                <p
                  onClick={() => {
                    history.push('/pagina/partners');
                    setMenuOpen(false);
                  }}
                >
                  Partners
                </p>
              </div>
            </div>
            <div
              onClick={() => setMenuOpen(false)}
              styleName="hamburger-menu-shade"
            />
          </>
        )}
      </div>
    </>
  );
}
